import React from "react";
import "./LearningLanesCard.css";

const definitions = [
  { key: "know_card", title: "Know", description: "Cards you already remember", icon: "bi bi-check2-all", iconClass: "know", countKey: "know" },
  { key: "still_learning_card", title: "Still Learning", description: "Cards that need another pass", icon: "fa-solid fa-circle-question", iconClass: "learning", countKey: "still_learning" },
  { key: "remaining_card", title: "Remaining", description: "Fresh cards waiting for you", icon: "bi bi-layers-fill", iconClass: "remaining", countKey: "remaining" },
  { key: "bookmarked_card", title: "Bookmarked", description: "Saved cards for quick revision", icon: "bi bi-star-fill", iconClass: "bookmarked", countKey: "total_bookmarked_count" },
];

const LearningLanes = ({ summary = {}, onSelect }) => (
  <section className="learning-lanes">
    <div className="learning-lanes__header"><h2 className="learning-lanes__title">Your learning lanes</h2><p className="learning-lanes__subtitle">Open the exact cards you want to revise next.</p></div>
    <div className="learning-lanes__grid">
      {definitions.map((lane) => <button type="button" className="learning-lane-card" key={lane.key} onClick={() => onSelect?.(lane.key)}>
        <div className={`learning-lane-card__icon learning-lane-card__icon--${lane.iconClass}`}><i className={lane.icon} /></div>
        <span className="learning-lane-card__arrow"><i className="bi bi-arrow-up-right" /></span>
        <div className="learning-lane-card__content"><div className="learning-lane-card__count">{Number(summary[lane.countKey] || 0)}</div><div className="learning-lane-card__title">{lane.title}</div><div className="learning-lane-card__description">{lane.description}</div></div>
      </button>)}
    </div>
  </section>
);

export default LearningLanes;
